module.exports = __webpack_public_path__ + "static/media/step-item-2.0f178bdf.svg";